/**
 * trp-accessibility.js
 *
 * The following adds controls and handlers to apply accessibility rules to the TRP Language Toggle. This file was previously added to our fork of the TranslatePress plugin, but moving it into the theme to make it easier to keep the plugin up to date.
 */

( function() {

	/**
	 * Global vars
	 */
	var trpContainer = null; // TRP Container
	var trpContainerToggle = null; // TRP Container Toggle
	var trpContainerList = null; // TRP Language List
	var trpCurrentLanguage = null; // TRP Current Language button wrapper
	var trpID = 'trp-floater-ls'; // TRP ID string for re-use
	var trpListID = 'trp-floater-ls-language-list'; // TRP List ID string for re-use
	var trpToggleClass = '.trp-floater-ls-disabled-language'; // TRP Toggle Class string for re-use
	var trpCurrentLanguageID = 'trp-floater-ls-current-language';

	/**
	 * Main initialize method will run checks against DOM
	 */
	function init() {

		// Get main TRP container
		trpContainer = document.getElementById( trpID );

		// Get TRP toggle
		trpContainerToggle = document.querySelectorAll( trpToggleClass );

		// Get TRP list
		trpContainerList = document.getElementById( trpListID );

		// Get TRP current language button wrapper
		trpCurrentLanguage = document.getElementById( trpCurrentLanguageID );

		// If either of the core elements not found, abandon script
		if ( ! trpContainer || 0 === trpContainerToggle.length ) return;

		// Continue with setup
		doSetup();
	}

	/**
	 * Main setup
	 */
	function doSetup() {
		doAriaSetup();
		doBindingsSetup();
	}

	/**
	 * Add aria control attributes to the DOM
	 */
	function doAriaSetup() {

		// Tell the DOM the container is collapsed
		trpContainer.setAttribute( 'aria-expanded', 'false' );
		trpCurrentLanguage.setAttribute('role', 'group');
		trpContainerList.querySelectorAll( 'a' ).forEach( ( item ) => {
			item.setAttribute('role', 'menuitem');
		});

		// Tell the DOM about controls pairing
		for( var i = 0, cnt = trpContainerToggle.length; i < cnt; i++ ) {
			trpContainerToggle[i].setAttribute( 'aria-controls', trpID );
		}
	}

	/**
	 * Add handlers to the DOM
	 */
	function doBindingsSetup() {

		// TRP Container mouse handlers
		trpContainer.addEventListener( 'mouseenter', doActiveAria );
		trpContainer.addEventListener( 'mouseleave', doInactiveAria );
		trpContainer.addEventListener( 'keyup', doKeyEvents );

		// TRP Toggle click handler
		for( var i = 0, cnt = trpContainerToggle.length; i < cnt; i++ ) {
			trpContainerToggle[i].addEventListener( 'click', doLangSwitcher );
		}
	}

	/**
	 * Handle the keyboard events
	 * @param {Object} e - Event Object
	 */
	function doKeyEvents( e ) {
		e.preventDefault();

		// If no event or keyCode, abandon
		if ( ! e || ! e.keyCode ) {
			return;
		}

		// Test which keyCode
		switch ( e.keyCode ) {
				// Up: focus first
				case 38:
					doExpandedFocus();
					break;

				// Down: focus toggle
				case 40:
					trpContainerToggle[1] && trpContainerToggle[1].focus();
					break;

				// Escape: collapse
				case 27:
					doLangSwitcher();
					break;
		}
	}

	/**
	 * Tell DOM with active updates to aria settings
	 */
	function doActiveAria() {
		trpContainer.setAttribute( 'aria-expanded', 'true' );
	}

	/**
	 * Tell DOM with inactive updates to aria settings
	 */
	function doInactiveAria() {
		trpContainer.setAttribute( 'aria-expanded', 'false' );
	}

	/**
	 * Tell DOM to focus on first child in lang list when expanded
	 */
	function doExpandedFocus() {

		// Get first child
		var firstChild = trpContainerList && trpContainerList.querySelector( 'a' );

		// If no first child, abandon
		if ( ! firstChild ) {
			return;
		}

		// Focus on first child
		firstChild.focus();
	}

	/**
	 * Tell DOM to focus on lang toggle when collapsed
	 */
	function doCollapsedFocus() {
		trpContainerToggle[0].focus();
	}

	/**
	 * Toggle Handler for the language switcher
	 * @param {Object} e - Event Object
	 */
	function doLangSwitcher( e ) { // eslint-disable-line no-unused-vars

		// Toggle the active class to expand/collapse
		trpContainer.classList.toggle( 'is-active' );

		// Tell aria about the state of the container
		if( trpContainer.classList.contains ( 'is-active' ) ) {

			// Active aria
			doActiveAria();

			// Focus on first item
			doExpandedFocus();
		} else {

			// Inactive aria
			doInactiveAria();

			// Focus on toggle
			doCollapsedFocus();
		}
	}

	// Initialize
	window.addEventListener( 'load', init );
} )();
